import React from 'react'

import { FormattedMessage } from 'react-intl'

import { ONE_DAY_IN_SECS } from 'utils/time'

import SdkDisclosureTable from '../SdkDisclosureTable'
import StorageDisclosureTable from '../StorageDisclosureTable'
import Locale from '../locale'


// 'content' has to be an array of strings or <FormattedMessage /> objects
export default function makeVendorDetails(vendorDetails) {
  const stdRetention = vendorDetails.dataRetention.stdRetention || 0

  return [
    {
      header: Locale.purposes,
      content: vendorDetails.purposes,
    },
    {
      header: Locale.specialPurposes,
      content: vendorDetails.specialPurposes,
    },
    {
      header: Locale.features,
      content: vendorDetails.features,
    },
    {
      header: Locale.specialFeatures,
      content: vendorDetails.specialFeatures,
    },
    {
      header: Locale.dataCategories,
      content: vendorDetails.dataDeclaration,
    },
    {
      header: Locale.privacyPolicy,
      content: [
        vendorDetails.privacyPolicyURL,
      ],
    },
    {
      header: Locale.storageAccess,
      content: [
        {
          ...Locale.maxDeviceStorageDuration,
          values: {
            maxDeviceStorageDuration: secondsToDays(vendorDetails.cookieMaxAgeSeconds),
          },
        },
        {
          ...Locale.usesCookies,
          values: {
            usesCookies: vendorDetails.usesCookies.toString(),
          },
        },
        {
          ...Locale.cookieRefresh,
          values: {
            cookieRefresh: vendorDetails.cookieRefresh.toString(),
          },
        },
        {
          ...Locale.usesNonCookieAccess,
          values: {
            usesNonCookieAccess: vendorDetails.usesNonCookieAccess.toString(),
          },
        },
      ],
    },
    {
      header: Locale.standardDataRetention,
      content: [
        <FormattedMessage
          key="std-retention"
          { ...Locale.retentionDays }
          values={ { number: stdRetention } }
        />,
      ],
    },
    {
      header: Locale.storageDisclosure,
      content: getStorageDisclosureContent(vendorDetails.storageDisclosures),
    },
    {
      header: Locale.sdkDisclosure,
      content: getSdkDisclosureContent(vendorDetails.sdks),
    },
  ]
}

function getSdkDisclosureContent(sdks) {
  if ( !sdks?.length ) {
    return []
  }

  return [
    <SdkDisclosureTable
      key="vsdkdt"
      sdks={ sdks }
    />,
  ]
}

function secondsToDays(seconds) {
  // eslint-disable-next-line eqeqeq
  if ( seconds == null ) {
    return 0
  }
  return Math.round(seconds / ONE_DAY_IN_SECS)
}

function getStorageDisclosureContent(storageDisclosures) {
  if ( !storageDisclosures?.length ) {
    return []
  }

  return [
    <StorageDisclosureTable
      key="vsdt"
      storageDisclosures={ storageDisclosures }
    />,
  ]
}
